export const BAMBOOHR_OAUTH_CALLBACK_PATH =
  "/integrations/bamboohr/oauth/callback";

export const getBambooHROAuthRedirectUri = (): string =>
  `${window.location.origin}${BAMBOOHR_OAUTH_CALLBACK_PATH}`;

const PENDING_SESSION_KEY = "bambooHR.oauth.pending";

export interface BambooOAuthState {
  datasourceId?: string;
  connectorId?: string;
  subdomain?: string;
  workspaceId?: string;
}

export interface BambooOAuthPending {
  connectorId: string;
  workspaceId: string;
  subdomain: string;
  redirectUri: string;
}

/**
 * Decode BambooHR OAuth state payload from the API (HMAC-signed body only;
 * signature verification happens server-side).
 */
export const parseBambooHROAuthState = (state: string): BambooOAuthState => {
  if (!state) {
    return {};
  }

  const body = state.includes(".")
    ? state.slice(0, state.lastIndexOf("."))
    : state;

  try {
    const base64 = body.replace(/-/g, "+").replace(/_/g, "/");
    const padded = base64 + "=".repeat((4 - (base64.length % 4)) % 4);
    const parsed = JSON.parse(atob(padded)) as BambooOAuthState & {
      nonce?: string;
      exp?: number;
    };
    const { nonce: _nonce, exp: _exp, ...statePayload } = parsed;
    return statePayload;
  } catch {
    return {};
  }
};

export const setBambooHROAuthPending = (pending: BambooOAuthPending): void => {
  sessionStorage.setItem(PENDING_SESSION_KEY, JSON.stringify(pending));
};

export const getBambooHROAuthPending =
  (): Partial<BambooOAuthPending> | null => {
    const raw = sessionStorage.getItem(PENDING_SESSION_KEY);
    if (!raw) {
      return null;
    }
    try {
      return JSON.parse(raw) as Partial<BambooOAuthPending>;
    } catch {
      return null;
    }
  };

export const clearBambooHROAuthPending = (): void => {
  sessionStorage.removeItem(PENDING_SESSION_KEY);
};
